<ng-container *ngIf="scorecard.Locked; else normalScorecard">
  <fgbcl-scorecard-locked
    [disabled]="disabled"
    [isSponsorInBody]="isSponsorInBody"
    [scorecard]="scorecard"
  ></fgbcl-scorecard-locked>
</ng-container>
<ng-template #normalScorecard>
  <div
    [ngClass]="{ 'scorecard-linked-shadow': scorecard?.ParentId || isScorecardHasChild }"
    class="scorecard scorecard-number scorecard-container col-12 px-0 d-flex flex-column justify-content-between scorecard-container-radius"
    (click)="openScorecardDescription()"
  >
    <!--Header-->
    <div>
      <div class="scorecard-count-container w-100 d-flex justify-content-between">
        <div class="d-flex">
          <img
            alt=""
            class="scorecard-image"
            [ngClass]="{ 'scorecard-one-punch-incomplete': !scorecard.Completed }"
            src="{{ scorecard.Image | contentImage: '7' : 'badge' }}"
            [useDefault]="true"
            [loyaltyType]="'badge'"
          />
          <span class="ps-3">
            <h3 class="scorecard-name scorecard-label-ellipsis" id="scorecard-number-name">
              {{ scorecard.Content[0].Name }}
            </h3>
            <p class="scorecard-description scorecard-label-ellipsis mb-2" id="scorecard-number-description">
              {{ scorecard.Content[0].ShortDescription }}
            </p>
          </span>
        </div>
      </div>
    </div>
    <div class="text-center mx-3 mb-2 mt-2 mt-lg-1">
      <h4 class="counter-number-scorecard scorecard-number-counter" id="scorecard-number-actions-completed">
        {{ scorecard.ActionsCompleted
        }}<ng-container *ngIf="scorecard.DisplayCounterLimit">/{{ scorecard.Actions.length }}</ng-container>
      </h4>
    </div>

    <div class="w-100">
      <div class="scorecard-footer-container">
        <div class="scorecard-prize-border">
          <ng-container
            *ngIf="
              scorecard.Completed && scorecard.CompleteAction == 6 && !scorecard?.HasCustomerSelectedPrize;
              else normalFooter
            "
          >
            <span class="scorecard-choose-prize-text" id="scorecard-completed-text">{{
              'scorecard.footer.choose.prize' | translate
            }}</span>
          </ng-container>

          <ng-template #normalFooter>
            <div class="scorecard-label-ellipsis scorecard-prize">
              <span class="scorecard-prize-label">{{ 'scorecard.prize' | translate }} </span>
              <span class="scorecard-prize-text" id="scorecard-completed-text">{{
                scorecard.Completed && scorecard.HasCustomerSelectedPrize
                  ? ('scorecard.footer.prize.selected' | translate)
                  : !scorecard.Completed && scorecard.CompleteAction == 6 && !scorecard.HasCustomerSelectedPrize
                    ? ('scorecard.footer.prize.selection' | translate)
                    : scorecard.Content[0].PrizeDescription
              }}</span>
            </div>
            <ng-container *ngIf="scorecard.Sponsor?.SponsorImage">
              <div class="sponsor-img-text">
                <img class="sponsor-img" [src]="scorecard.Sponsor.SponsorImage | contentImage: '30'" />
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
